/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import { Input } from 'antd';
import axios from 'axios';
// import { ordersAPI, orderSummaryAPI } from '../../api/Api';
import { ordersAPI, orderSummaryAPI, orderDetails } from '../../api/ENDPOINTS/orders';
import { ordersOverview } from '../../api/ENDPOINTS/overview';
import { fetchData } from '../../api/GET/fetchData';
import { loginToken, localLoginToken } from '../../authorization/login';
import { ALERT_SHOW } from '../alerts/alertActionTypes';
import { dismissAlert } from '../alerts/alertsActions';
import {
    DETAILS_INPUT,
    DETAILS_LOADING,
    FETCH_ORDERS_DATA,
    FETCH_ORDERS_SUMMARY,
    FETCH_ORDER_DETAILS,
    FETCH_ORDER_NOTES,
    LIST_LOADING,
    NEW_ORDER_NOTE,
    NOTES_LOADING,
    ORDER_NOTE_INPUT,
    ORDER_NOTE_STATUS_MSG,
    ORDER_TRACKING_INPUT,
    ORDER_TRACKING_INPUT_RESET,
    SET_SELECTED_DATA,
    SET_SINGLE_ORDER_DATA,
    UPDATE_ORDER_DETAILS,
} from './ordersActionTypes';

/* Fetching All Orders Data
ACTION: 
1. Initial Orders Data Fetching
2. Fetch Again if any Query ParameterChanges

Payload: 
1. Response Data
2. Total Order Page (from Header)
*/
export const fetchOrdersData = (queryStatus = '') => async (dispatch) => {
    dispatch({
        type: LIST_LOADING,
        payload: true,
    });
    const response = await fetchData(`${ordersAPI}/${queryStatus}`);
    await dispatch({
        type: FETCH_ORDERS_DATA,
        payload: response.data,
        ordersTotalPages: response.headers['x-wp-totalpages'] ?? 0,
    });

    dispatch({
        type: LIST_LOADING,
        payload: false,
    });
};

/* Fetching Orders Summary
ACTION: 
1. Fetch Orders Summary

Payload: 
1. Response Data
*/
export const fetchOrdersSummary = () => async (dispatch) => {
    const response = await fetchData(ordersOverview);
    dispatch({
        type: FETCH_ORDERS_SUMMARY,
        payload: response?.data,
    });
};

/* Fetching SINGLE ORDER
ACTION: 
1. Fetch Orders Summary

Payload: 
1. Response Data
*/
export const fetchOrderDetails = (id) => async (dispatch) => {
    const response = await axios.get(`${ordersAPI}/${id}`, {
        headers: {
            Authorization: `Basic ${loginToken}`,
        },
    });
    dispatch({
        type: FETCH_ORDER_DETAILS,
        payload: response.data,
    });
};

/**
 * Set Selected Row Keys
 * Payload: []
 */

export function setSelectedRowKeys(payload = []) {
    return (dispatch) => {
        dispatch({
            type: SET_SELECTED_DATA,
            payload,
        });
    };
}

export function setSingleOrder(payload) {
    return async (dispatch, getState) => {
        // const {ordersData} = await getState().orders;
        // // eslint-disable-next-line eqeqeq
        // const singleData = ordersData.find((item) => item.id == payload)
        dispatch({
            type: DETAILS_LOADING,
            payload: true,
        });
        const res = await axios.get(`${ordersAPI}/${payload}`, {
            headers: {
                Authorization: `Basic ${localLoginToken}`,
            },
        });

        dispatch({
            type: SET_SINGLE_ORDER_DATA,
            payload: res.data,
        });
        dispatch({
            type: DETAILS_LOADING,
            payload: false,
        });
    };
}

export function listLoader(payload) {
    return (dispatch) => {
        dispatch({
            type: LIST_LOADING,
            payload,
        });
    };
}

export function handleDetailsInput(input) {
    return (dispatch) => {
        dispatch({
            type: DETAILS_INPUT,
            payload: input,
        });
    };
}
export function updateOrderDetails(payload) {
    const data = { status: `wc-${payload.status}` };
    const alert = {
        message: 'Order Details Successfully Updated...!!!',
        alertType: 'success',
        status: 200,
    };
    return async (dispatch) => {
        dispatch({
            type: DETAILS_LOADING,
            payload: true,
        });
        const res = await axios.post(`${ordersAPI}/${payload.id}`, data, {
            headers: {
                Authorization: `Basic ${localLoginToken}`,
            },
        });
        dispatch({
            type: UPDATE_ORDER_DETAILS,
            payload: res.data,
        });
        dispatch({ type: ALERT_SHOW, payload: alert });
        dispatch({
            type: DETAILS_LOADING,
            payload: false,
        });

        setTimeout(() => {
            dispatch(dismissAlert());
        }, 2000);
    };
}

export function fetchOrderNotes(orderId) {
    return async (dispatch) => {
        const response = await fetchData(`${ordersAPI}/${orderId}/notes`);

        dispatch({
            type: FETCH_ORDER_NOTES,
            payload: response.data,
        });
    };
}

export function handleOrderNoteInput(noteInput) {
    if (noteInput.name === 'customer_note') {
        if (noteInput.value !== 'customer_note') {
            // eslint-disable-next-line no-param-reassign
            noteInput.value = '';
        }
    }
    return async (dispatch) => {
        dispatch({
            type: ORDER_NOTE_INPUT,
            payload: noteInput,
        });
    };
}

export function handleTrackingNoInput(noteInput) {
    console.log(noteInput);
    return async (dispatch) => {
        dispatch({
            type: ORDER_TRACKING_INPUT,
            payload: noteInput,
        });
    };
}

export function createNewOrderNote(payload, orderId) {
    return async (dispatch) => {
        dispatch({
            type: NOTES_LOADING,
            payload: true,
        });
        if (payload.note) {
            const response = await axios.post(`${ordersAPI}/${orderId}/notes`, payload, {
                headers: {
                    Authorization: `Basic ${localLoginToken}`,
                },
            });
            dispatch(fetchOrderNotes(orderId));
        } else {
            const bag = {
                status: 'error',
                message: 'please enter order note',
            };

            dispatch({
                type: ORDER_NOTE_STATUS_MSG,
                payload: bag,
            });
        }
        dispatch({
            type: NEW_ORDER_NOTE,
            payload: '',
        });
        setTimeout(() => {
            dispatch({
                type: ORDER_NOTE_STATUS_MSG,
                payload: {
                    status: '',
                    message: '',
                },
            });
            dispatch({
                type: NOTES_LOADING,
                payload: false,
            });
        }, 3000);
    };
}

export function createTrackingNumber(payload, orderId) {
    let textFormat;
    if (payload.provider) {
        textFormat = Object.keys(payload)
            .map((key) => `Shipping ${key}:${payload[key]}`)
            .join('\n');
    }
    return async (dispatch, getState) => {
        const { newCustomerNote } = getState().orders;
        const newTrackingNote = { ...newCustomerNote, note: textFormat || '', status: 'pending' };
        dispatch(createNewOrderNote(newTrackingNote, orderId));
        dispatch({
            type: ORDER_TRACKING_INPUT_RESET,
            payload: { provider: '', number: '', date: '' },
        });
    };
}
export function deleteOrderNote(orderId, noteID) {
    return async (dispatch) => {
        dispatch({
            type: NOTES_LOADING,
            payload: true,
        });
        const response = await axios.delete(`${ordersAPI}/${orderId}/notes/${noteID}`, {
            headers: {
                Authorization: `Basic ${localLoginToken}`,
            },
        });
        await dispatch(fetchOrderNotes(orderId));
        dispatch({
            type: '',
            payload: '',
        });
        dispatch({
            type: NOTES_LOADING,
            payload: false,
        });
    };
}
